import { useGameStore } from '@/store/gameStore';

export function useHudMetrics() {
  const energy = useGameStore((state) => state.energy);
  const combo = useGameStore((state) => state.combo);
  const tapCount = useGameStore((state) => state.tapCount);
  const activeTouches = useGameStore((state) => state.activeTouches);
  const platformLabel = useGameStore((state) => state.platformLabel);

  return { energy, combo, tapCount, activeTouches, platformLabel };
}

export function useHudStatus() {
  const sceneReady = useGameStore((state) => state.sceneReady);
  const status = useGameStore((state) => state.status);
  const appVersion = useGameStore((state) => state.appVersion);

  return { sceneReady, status, appVersion };
}

export function useHudToggles() {
  const audioEnabled = useGameStore((state) => state.audioEnabled);
  const toggleAudio = useGameStore((state) => state.toggleAudio);

  return { audioEnabled, toggleAudio };
}
